import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import Select from "react-select";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import ReactQuill from "react-quill";
import { get, post, put, uri } from "helpers/api_helper";
import * as api from "../../constants/api_constants";
import { charactersWithSpaces, zipcode } from "helpers/validations/regex";
import { number } from "prop-types";
import { formatToPascal } from "helpers/utils/nameUtils";
import DragAndDropComponent from "components/FileUploadDrag/DragAndDrop";

export default function ViewAssignment() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  console.log("projects",projects);
  
  const [employees, setEmployees] = useState([]);
  const [assignmentData, setAssignmentData] = useState({});
  const { AssignId } = useParams();
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [assignmentDocuments, setAssignmentDocuments] = useState({});

  useEffect(() => {
    employeeData();
    fetchProjects();

    if (AssignId) {
      fetchAssignment();
    }
  }, []);

  
  
  const employeeData = async () => {
    try {
      const response = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      const employeeResponse = response.map((item) => ({
        value: item.employeeId,
        label: `${item.firstName}  ${item.lastName}`,
        number: item.number,
        email: item.email,
      }));

      setEmployees(employeeResponse);
      setEmployeeOptions(employeeResponse);

      // console.log("employeeResponse", employeeResponse);
    } catch (error) {
      console.log("Error fetching employees data");
    }
  };

  const fetchAssignment = async () => {
    try {
      const response = await get(api.GET_ASSIGNMENT_BY_ID(AssignId));
      // console.log("Response:", response);
      const assignData = response.data;

      // console.log("AssignData:", assignData);
      const res = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      const employeeResponse = res.map((item) => ({
        value: item.employeeId,
        label: `${item.firstName}  ${item.lastName}`,
        number: item.number,
        email: item.email,
      }));
      // console.log(employeeResponse);

      

      const assignmentDoc = assignData?.assignmentDocuments || [];
      const fileDetails = await Promise.all(
        assignmentDoc.map(async (fileId) => {
          try {
            const fileResponse = await get(
              `${uri}/fileservice/api/files/view/${fileId}`
            );
            return {
              id: fileResponse.id,
              fileName: fileResponse.fileName,
              name: fileResponse.fileName, // Match AddProject's structure
              path: fileResponse.path || `/uploads/${fileResponse.fileName}`,
            };
          } catch (error) {
            console.error(`Error fetching file ${fileId}:`, error);
            return null;
          }
        })
      );
      setAssignmentDocuments(fileDetails.filter((file) => file !== null));
      // console.log("ass", assignmentDocuments);

      setAssignmentData({
        assignmentTitle: assignData?.assignmentTitle || "",
        startDate: assignData?.startDate.slice(0, 10) || "",
        endDate: assignData?.endDate.slice(0, 10) || "",
        placementType: formatToPascal(assignData?.placementType) || "",
        status: formatToPascal(assignData?.status) || "",
        project: assignData?.projectId || [],
        hiringType: formatToPascal(assignData?.hiringType) || "",
        workType: formatToPascal(assignData?.workLocationDTO?.workType) || "",
        workLocationCountry: assignData?.workLocationDTO?.country || "",
        workLocationZipCode: assignData?.workLocationDTO?.zipCode || "",
        workLocationProvince: assignData?.workLocationDTO?.province || "", // Not provided in response
        workLocationCity: assignData?.workLocationDTO?.city || "",
        workLocationAddress: assignData?.workLocationDTO?.address || "",
        workDetailsId: assignData?.workLocationDTO?.id || "",
        reportingManagerName:
          assignData?.workLocationDTO?.reportingManagerId || "",
        reportingManagerNumber:
          assignData?.workLocationDTO?.reportingManagerNumber || "",
        reportingManagerEmail:
          assignData?.workLocationDTO?.reportingManagerEmail || "",
        // projectManager: projectManager?.label || "",
        recruitmentDetailsId: assignData?.recruitmentDTO?.id || "",
        jobId: assignData?.recruitmentDTO?.jobId || "",
        // recruitmentManager: recruitmentManager?.label || "",
        recruiter: assignData?.recruitmentDTO?.recruiterId || "",
        externalRecruiters:
          assignData?.recruitmentDTO?.externalRecruitersId || "",
        billDetailsId: assignData?.billingDTO?.id || "",
        payType: formatToPascal(assignData?.billingDTO?.payType) || "",
        billType: formatToPascal(assignData?.billingDTO?.billType) || "",
        payRate: assignData?.billingDTO?.payRate || "",
        effectiveFrom:
          assignData?.billingDTO?.effectiveForm?.slice(0, 10) || "",
        currency: formatToPascal(assignData?.billingDTO?.currencyType) || "",
        comments: assignData?.billingDTO?.comments || "",
        teamMembers: assignData?.employeeIds || [],
        jiraUrl: assignData?.jiraUrl || "",
        gitHubUrl: assignData?.gitHubUrl || ""
      });

      // console.log("Fetched assignment data:", assignmentData);
    } catch (error) {
      console.log("Error fetching assignment data:", error);
    }
  };
   
  const fetchProjects = async () => {
    try {
      debugger
      const projectsData = await get(api.GET_ALL_PROJECTS_ID_NAMES);
      console.log("projectsData",projectsData);
      
      const updatedProjectData = projectsData?.paginationResponse?.data.map(
        (item) => ({
          value: item.projectId,
          label: `${item.projectName} - (${item.projectCode})`,
        })
      );
      setProjects(updatedProjectData);
    } catch (error) {
      console.log("Error fetching projects data");
    }
  };
  // console.log("Projects", projects);

  const handleManagerChange = (e) => {
    const selectedId = parseInt(e.target.value);

    const selectedManager = employees.find(
      (employee) => employee.value === selectedId
    );
    validation.setFieldValue(
      "reportingManagerName",
      selectedManager ? selectedManager.value : ""
    );

    validation.setFieldValue(
      "reportingManagerNumber",
      selectedManager ? selectedManager.number : ""
    );

    validation.setFieldValue(
      "reportingManagerEmail",
      selectedManager ? selectedManager.email : ""
    );
  };

  // console.log("assignedData", assignmentData);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: AssignId
      ? assignmentData
      : {
          assignmentTitle: "",
          startDate: "",
          endDate: "",
          placementType: "",
          status: "",
          project: "",
          hiringType: "",
          workType: "",
          workLocationCountry: "",
          workLocationZipCode: "",
          workLocationProvince: "",
          workLocationCity: "",
          workLocationAddress: "",
          reportingManagerName: "",
          reportingManagerNumber: "",
          reportingManagerEmail: "",
          projectManager: "",
          jobId: "",
          recruitmentManager: "",
          recruiter: "",
          externalRecruiters: [],
          payType: "",
          billType: "",
          payRate: "",
          effectiveFrom: "",
          currency: "",
          comments: "",
          teamMembers: [],
          jiraUrl:"",
          gitHubUrl:"",
        },
    validationSchema: Yup.object({
      assignmentTitle: Yup.string()
        .required("Please enter assignment title")
        .matches(charactersWithSpaces, "Title should contain only characters"),
      startDate: Yup.date().required("Please enter start date"),
      endDate: Yup.date()
        .required("Please enter end date")
        .min(Yup.ref("startDate"), "End date must be after start date"),
      status: Yup.string().required("Please select status"),
      project: Yup.string().required("Please select project"),
      hiringType: Yup.string().required("Please select hiring type"),
      workType: Yup.string().required("Please select work type"),
      workLocationCountry: Yup.string()
        .required("Please enter country")
        .matches(
          charactersWithSpaces,
          "Country Name should contain characters only"
        ),
      workLocationZipCode: Yup.string()
        .required("Please enter zip code")
        .matches(zipcode, "Enter a valid zip code"),
      workLocationProvince: Yup.string().required("Please enter province"),
      workLocationCity: Yup.string()
        .required("Please enter city")
        .matches(charactersWithSpaces, "City should only contain characters"),
      workLocationAddress: Yup.string().required("Please enter address"),
      reportingManagerName: Yup.string().required("Please select manager name"),
      reportingManagerNumber: Yup.string().required(
        "Please enter manager number"
      ),
      reportingManagerEmail: Yup.string()
        .email()
        .required("Please enter a valid email"),
      recruiter: Yup.string().required("Please enter a recruiter name"),
      payType: Yup.string().required("Please select pay type"),
      billType: Yup.string().required("Please select bill type"),
      payRate: Yup.number()
        .required("Please enter pay rate")
        .positive("Pay rate must be positive"),
      effectiveFrom: Yup.date().required("Please enter effective date"),
    }),

    onSubmit: async (values) => {
      try {
        // Structuring the data based on the expected format
        const payload = {
          assignmentDTO: {
            assignmentTitle: values.assignmentTitle,
            assignmentId: parseInt(AssignId),
            startDate: values.startDate,
            subscrptionId: 100,
            projectId: values.project,
            endDate: values.endDate,
            status: values.status, // Enum value from Status
            placementType: values.placementType, // Enum value from PlacementType
            hiringType: values.hiringType, // Enum value from HiringType
            workLocationDTO: {
              id: assignmentData.workDetailsId || "",
              workType: values.workType, // Enum value from WorkType
              country: values.workLocationCountry,
              city: values.workLocationCity,
              address: values.workLocationAddress,
              province: values.workLocationProvince,
              reportingManagerName: parseInt(values.reportingManagerName),
              reportingManagerNumber: values.reportingManagerNumber,
              reportingManagerEmail: values.reportingManagerEmail,
              zipCode: values.workLocationZipCode,
            },
            recruitmentDTO: {
              id: assignmentData.recruitmentDetailsId || "",
              projectManagerId: parseInt(values.projectManager),
              jobId: values.jobId,
              recruiterId: values.recruiter,
              recruitmentManagerId: parseInt(values.recruitmentManager),
              externalRecruiter: [],
            },
            billingDTO: {
              id: assignmentData.billDetailsId || "",
              payType: values.payType, // Enum value from PayType
              billType: values.billType, // Enum value from BillType
              payRate: values.payRate,
              currencyType: values.currency,
              comments: values.comments,
              effectiveForm: values.effectiveFrom,
            },
            employeeIds: values.teamMembers,
          },
        };
        if (AssignId) {
          const response = await put(
            api.UPDATE_ASSIGNMENT_BY_ID(AssignId),
            payload
          );
          if (response.success) {
            navigate("/assignments");
          }
        } else {
          const response = await post(api.CREATE_ASSIGNMENT, payload);
          if (response.success) {
            navigate("/assignments");
          }
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });

  // console.log("validation", assignmentData);
  return (
    <>
      <div className="page-content">
        <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
          {/* <PageSubHeader
            heading={AssignId ? "Edit Assignment" : "Add Assignment" }
            routePath={"Home"}
            pageName={AssignId ? "Edit Assignment" : "Add Assignment"}
          /> */}
          {/* <PageSubHeader heading={"View Assignment"} /> */}

          <PageSubHeader
            heading={"View Assignment"}
            routePath={"Home"}
            pageName={"Assignment Details"}
          />
          <Row className="p-4">
            <Col>
              <Card>
                <CardBody>
                  <Form
                    className="row g-3 needs-validation py-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row className="card-group  ">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Assignment Details </p>
                      </Col>
                      <Col md="6" className="pt-2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="assignmentTitle">
                            Assignment Title{" "}
                            
                          </Label>
                          <Input
                            name="assignmentTitle"
                            type="text"
                            className="form-control"
                            id="assignmentTitle"
                            value={validation.values.assignmentTitle || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" className="pt-2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="teamMembers">
                            Team 
                          </Label>
                          <Select
                            isMulti
                            name="teamMembers"
                            options={employees}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={employees.filter((empId) =>
                              (validation.values.teamMembers || []).includes(
                                empId.value
                              )
                            )}
                            // value={validation.values.teamMembers || [] }

                            isDisabled={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="reportingManagerName">
                            Reporting Manager Name{" "}
                            
                          </Label>
                          <Input
                            name="reportingManagerName"
                            type="text"
                            //   className="form-select"
                            id="reportingManagerName"
                            value={
                              employeeOptions.find(
                                (emp) =>
                                  emp.value ===
                                  parseInt(
                                    validation.values.reportingManagerName
                                  )
                              )?.label || ""
                            }
                            // value={validation.values.reportingManagerName || ""}
                            // value={assignmentData.filter((magId)=>{
                            //   (validation.values.reportingManagerName || []).includes(
                            //     magId.value
                            //   )
                            // })}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="project">
                            Project 
                          </Label>
                          <Input
                            name="project"
                            type="text"
                            //  //   className="form-select"
                            id="project"
                            // value={validation.values.project || ""}
                            value={
                              projects.find(
                                (proj) =>
                                  proj.value === validation.values.project
                              )?.label || ""
                            }
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="startDate">
                            Start Date 
                          </Label>
                          <Input
                            name="startDate"
                            type="date"
                            className="form-control"
                            id="startDate"
                            value={validation.values.startDate || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="endDate">End Date</Label>
                          <Input
                            name="endDate"
                            type="date"
                            className="form-control"
                            id="endDate"
                            value={validation.values.endDate || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      {/* <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="placementType">Placement Type</Label>
                          <Input
                            name="placementType"
                            type="text"
                           //  //   className="form-select"
                            id="placementType"
                            value={validation.values.placementType || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col> */}

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="status">
                            Status 
                          </Label>
                          <Input
                            name="status"
                            type="text"
                            //  //   className="form-select"
                            id="status"
                            value={validation.values.status || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="jiraUrl">
                            jiraURL 
                          </Label>
                          <Input
                            disabled
                            name="jiraUrl"
                            className="form-control"
                            id="jiraUrl"
                            value={validation.values.jiraUrl || ""}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="gitUrl">
                            gitURL 
                          </Label>
                          <Input
                            disabled
                            name="gitUrl"
                            className="form-control"
                            id="gitUrl"
                            value={validation.values.gitHubUrl || ""}
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="workType">
                            Work Type 
                          </Label>
                          <Input
                            type="text"
                            name="workType"
                           //  //   className="form-select"
                            id="workType"
                            value={validation.values.workType || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col> */}

                      {/* <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="hiringType">
                            Hiring Type 
                          </Label>
                          <Input
                            name="hiringType"
                            type="text"
                           //  //   className="form-select"
                            id="hiringType"
                            value={validation.values.hiringType || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col> */}
                    </Row>

                    {/* <Row>
                      <h4 className="card-title text-primary py-2">
                        Work Location Details
                      </h4>

                      

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="workLocationCountry">
                            Work Location Country{" "}
                            
                          </Label>
                          <Input
                            name="workLocationCountry"
                            type="text"
                            className="form-control"
                            id="workLocationCountry"
                            value={validation.values.workLocationCountry || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="workLocationProvince">
                            Work Location Province{" "}
                            
                          </Label>
                          <Input
                            name="workLocationProvince"
                            type="text"
                            className="form-control"
                            id="workLocationProvince"
                            value={validation.values.workLocationProvince || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="workLocationCity">
                            Work Location City{" "}
                            
                          </Label>
                          <Input
                            name="workLocationCity"
                            type="text"
                            className="form-control"
                            id="workLocationCity"
                            value={validation.values.workLocationCity || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="workLocationZipCode">
                            Work Location Zip Code{" "}
                            
                          </Label>
                          <Input
                            name="workLocationZipCode"
                            type="text"
                            className="form-control"
                            value={validation.values.workLocationZipCode || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="workLocationAddress">
                            Work Location Address{" "}
                            
                          </Label>
                          <Input
                            name="workLocationAddress"
                            type="textarea"
                            rows={3}
                            className="form-control"
                            id="workLocationAddress"
                            value={validation.values.workLocationAddress || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row> */}

                    {/* <Row>
                      <h4 className="card-title text-primary py-2">
                        Reporting Manager Details
                      </h4>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="reportingManagerName">
                            Reporting Manager Name{" "}
                            
                          </Label>
                          <Input
                            name="reportingManagerName"
                            type="text"
                           //   className="form-select"
                            id="reportingManagerName"
                            value={validation.values.reportingManagerName || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="reportingManagerNumber">
                            Reporting Manager Number{" "}
                            
                          </Label>
                          <Input
                            name="reportingManagerNumber"
                            type="text"
                            className="form-control"
                            id="reportingManagerNumber"
                            value={
                              validation.values.reportingManagerNumber || ""
                            }
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="reportingManagerEmail">
                            Reporting Manager Email{" "}
                            
                          </Label>
                          <Input
                            name="reportingManagerEmail"
                            type="email"
                            className="form-control"
                            id="reportingManagerEmail"
                            value={
                              validation.values.reportingManagerEmail || ""
                            }
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row> */}

                    {/* <Row>
                      <h4 className="card-title text-primary py-2">
                        Recruitment Details
                      </h4>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="projectManager">
                            Project Manager{" "}
                          </Label>
                          <Input
                            name="projectManager"
                            type="text"
                           //   className="form-select"
                            id="projectManager"
                            value={validation.values.projectManager || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="jobId">Job ID</Label>
                          <Input
                            name="jobId"
                            type="text"
                            className="form-control"
                            id="jobId"
                            value={validation.values.jobId || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="recruitmentManager">
                            Recruitment Manager{" "}
                          </Label>
                          <Input
                            name="recruitmentManager"
                            type="text"
                           //   className="form-select"
                            id="recruitmentManager"
                            value={validation.values.recruitmentManager || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="recruiter">
                            Recruiter
                          </Label>
                          <Input
                            name="recruiter"
                            type="text"
                           //   className="form-select"
                            id="recruiter"
                            value={validation.values.recruiter || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="externalRecruiters">
                            External Recruiters
                          </Label>
                          <Input
                            name="externalRecruiters"
                            type="text"
                            className="form-control"
                            id="externalRecruiters"
                            value={validation.values.externalRecruiters || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row> */}

                    <Row className="card-group  my-2">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Billing Information </p>
                      </Col>

                      <Col md="6" className="pt-2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="payType">
                            Pay Type 
                          </Label>
                          <Input
                            type="text"
                            name="payType"
                            //   className="form-select"
                            id="payType"
                            value={validation.values.payType || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md="6" className="pt-2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="billType">
                            Bill Type 
                          </Label>
                          <Input
                            type="text"
                            name="billType"
                            //   className="form-select"
                            id="billType"
                            value={validation.values.billType || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="currency">Currency</Label>
                          <Input
                            name="currency"
                            type="text"
                            className="form-control"
                            id="currency"
                            value={validation.values.currency || ""}
                            disabled
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="payRate">
                            Pay Rate 
                          </Label>
                          <Input
                            name="payRate"
                            type="text"
                            className="form-control"
                            id="payRate"
                            value={validation.values.payRate || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="effectiveFrom">
                            Effective From{" "}
                            
                          </Label>
                          <Input
                            name="effectiveFrom"
                            type="date"
                            className="form-control"
                            id="effectiveFrom"
                            value={validation.values.effectiveFrom || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="comments">Comments</Label>
                          <Input
                            name="comments"
                            type="textarea"
                            rows={3}
                            className="form-control"
                            id="comments"
                            value={validation.values.comments || ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="card-group mt-3 flex">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Project Documents</p>
                      </Col>
                      <Col md={3}>
                        {assignmentDocuments.length > 0 ? (
                          assignmentDocuments.map((doc) => (
                            <div
                              key={doc.id}
                              className="position-relative rounded py-2 pe-4 mb-3"
                            >
                              <DragAndDropComponent
                                initialFile={doc}
                                readOnly={true}
                              />
                            </div>
                          ))
                        ) : (
                          <p>No documents available.</p>
                        )}
                      </Col>
                    </Row>

                    {/* Footer and Save/Cancel Buttons */}
                    <Footer
                      saveText="Edit Assignment"
                      save={() => navigate(`/add-assignment/${AssignId}`)}
                      showBackConfirmation={false}
                    />
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
